import type { CaptureContext } from '@sentry/core';
import { captureException } from '@sentry/react';

import { safeCall, safeCallAsync } from './safe-call';
import { Result } from './safe-call.types';

/**
 * Slightly modified version of safeCall and safeCallAsync
 * Besides returning the result and error, it also captures the error using Sentry.
 */

export async function safeCallWithSentryAsync<T, E = Error>(
  promise: Promise<T>,
  context?: CaptureContext,
): Promise<Result<T, E>> {
  const [result, error] = await safeCallAsync<T, E>(promise);
  if (error) {
    captureException(error, context);
    return [null, error];
  }
  return [result as T, null];
}

export function safeCallWithSentry<T, E = Error>(
  fn: () => T,
  context?: CaptureContext,
): Result<T, E> {
  const [result, error] = safeCall<T, E>(fn);
  if (error) {
    captureException(error, context);
    return [null, error];
  }
  return [result as T, null];
}
